<sbnb-apps-detail-page
  vendorCode="houfy"
  name="Houfy"
  logoTile="/assets/images/apps/houfy.png"
  builtBy="Houfy"
  builtByLink="https://houfy.com"
  [categories]="['Direct bookings']"
  [permissions]="[AppPermission.calendarRead, AppPermission.propertyRead, AppPermission.reservationRead]"
  email="info@houfy.com"
  [helpArticles]="[
    {
      id: '10126925',
      title: 'Connect Hospitable with Houfy to create an integrated direct booking site'
    }
  ]">
  <div style="position: relative; padding-bottom: 56.25%; height: 0">
    <iframe
      src="https://www.youtube.com/embed/vhO5-yHvQbM"
      frameborder="0"
      allowfullscreen
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
  </div>
  <ng-container description>
    <p>
      Discover the seamless integration between Houfy and Hospitable that is the next chapter in property management. By
      listing your properties on Houfy, you not only leverage a commission-free platform that can maximize your earnings
      by up to 15% more per night but also enjoy the streamlined operations facilitated by Hospitable. Here’s how easy
      it is to connect and expand your property management capabilities:
    </p>

    <p><strong>Integration Steps:</strong></p>

    <strong>1. Access Your Houfy Account Settings</strong>
    <ul class="list list__looser">
      <li>Log into your Houfy account.</li>
      <li>Navigate to the dropdown menu at the top right corner of your profile and select ‘Manage Listings’.</li>
    </ul>

    <strong>2. Establish Your Connections</strong>
    <ul class="list list__looser">
      <li>From the main menu on the left, click ‘API Connections’ to explore available integrations.</li>
      <li>You’ll find options like Hospitable.</li>
    </ul>

    <strong>3. Activate Your Integration</strong>
    <ul class="list list__looser">
      <li>Click on ‘Connect’ next to Hospitable to start the integration process.</li>
      <li>You will be directed to your hospitable login page and will have to authorize Houfy to access Hospitable.</li>
    </ul>

    <strong>4. Complete the Integration</strong>
    <ul class="list list__looser">
      <li>
        You will now be able to select your listings and which relevant information you would like to map or import
      </li>
      <li>
        Once integrated, Houfy will synchronize with Hospitable, enhancing your operational efficiency and guest
        engagement.
      </li>
    </ul>

    <p><strong>Why Choose Houfy for Your Hospitable Listings?</strong></p>
    <ul class="list list__looser">
      <li>
        <strong>Maximized Earnings:</strong>
        With zero commission fees, keep more of what you earn, making your property listings more profitable.
      </li>
      <li>
        <strong>Direct Payouts:</strong>
        Enjoy immediate access to your funds through reliable payment channels like Stripe or Square, ensuring quick and
        hassle-free transactions.
      </li>
      <li>
        <strong>Full Control:</strong>
        Manage every aspect of your listings from pricing to guest interactions directly through Houfy, giving you
        complete authority over your rental business.
      </li>
    </ul>

    <p><strong>Empower Your Rental Business with Houfy</strong></p>

    <p>
      Integrating Houfy with Hospitable not only simplifies property management but also enhances visibility. By joining
      Houfy, you gain access to a platform that prioritizes your profits and operational abilities, all while delivering
      an exceptional booking experience to your guests, entirely commission-free.
    </p>
  </ng-container>
</sbnb-apps-detail-page>
